<app-modal-dialog (backdropClick)="onKeepLocal()">
  <div header>
    <h2>{{ 'sync.database_updated' | translate }}</h2>
    <p class="subtitle">{{ 'sync.database_updated_description' | translate }}</p>
  </div>
  <div content>
    <div class="warning-box">
      <svg class="warning-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
        <line x1="12" y1="9" x2="12" y2="13"></line>
        <line x1="12" y1="17" x2="12.01" y2="17"></line>
      </svg>
      <p>{{ 'sync.local_data_outdated' | translate }}</p>
    </div>

    <div class="options">
      <div class="option">
        <h3>{{ 'sync.reset_and_resync' | translate }}</h3>
        <p>{{ 'sync.reset_and_resync_description' | translate }}</p>
      </div>
      <div class="option">
        <h3>{{ 'sync.keep_local_data' | translate }}</h3>
        <p>{{ 'sync.keep_local_data_description' | translate }}</p>
      </div>
    </div>

    <p class="note">{{ 'sync.auth_tokens_preserved' | translate }}</p>
  </div>
  <div footer>
    <app-button variant="text" (click)="onKeepLocal()">
      {{ 'sync.keep_local_data' | translate }}
    </app-button>
    <app-button (click)="onReset()">
      {{ 'sync.reset_and_resync' | translate }}
    </app-button>
  </div>
</app-modal-dialog>